<ng-container *ngIf="vo$ | async; let vo">
    <app-page>

        <app-page-content>
            <app-panel
                headerHeight="3rem"
                isAlwaysOpen="true"
                hasRefresh="true"
                [itemsCount]="vo.total"
                >

                    <div panel-title class="app-panel__title">
                        <span i18n="@@trace.list.title">
                            Traces
                        </span>
                    </div>
                    <dx-data-grid
                        keyExpr="id"
                        [elementAttr]="{ id: 'trace-list', class: 'app-trace-list' }"
                        [dataSource]="dataSource"
                        [remoteOperations]="true"
                        [hoverStateEnabled]="true"
                        [showColumnHeaders]="true"
                        [allowColumnResizing]="false"
                        [columnAutoWidth]="false"
                        [showRowLines]="false"
                        [showColumnLines]="false"
                        [rowAlternationEnabled]="false"
                        [showBorders]="false"
                        [width]="'100%'"
                        [selection]="{ mode: 'none' }"
                        (onOptionChanged)="onPageChange($event)"
												(onContentReady)="onGridContentReady()"
                        >


                        <dxo-header-filter [visible]="false"></dxo-header-filter>

                        <dxo-load-panel
                            shadingColor="rgba(0,0,0,0)"
                            [indicatorSrc]="DcLoaders.LoaderInfinite"
                            [height]="100"
                            [width]="100"
                            [enabled]="vo.isFirstLoad"
                            [showIndicator]="true"
                            [showPane]="true"
                            [shading]="true"></dxo-load-panel>

                        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

                        <ng-container *ngFor="let col of vo.list.availableColumns | toArray">
                            <dxi-column
                                *ngIf="col.field === 'code'"
                                [dataField]="col.field"
                                [caption]="col.alias"
                                [groupIndex]="col.groupIdx"
                                [visibleIndex]="col.visibleIndex"
                                [fixed]="false"
                                [allowResizing]="true"
                                [allowHiding]="true"
                                [allowGrouping]="true"
                                [allowSearch]="col.isSearchable"
                                [allowFiltering]="col.isFilterable"
                                [allowSorting]="true"
                                [allowHeaderFiltering]="col.hasHeaderFilter"
                                [format]="col.format"
                                [alignment]="'left'"
                                [allowEditing]="true"
                                [visible]="col.visible"
                                cellTemplate="codeTemplate"></dxi-column>
                            <dxi-column
                                *ngIf="col.field === 'usedDate'"
                                [dataField]="col.field"
                                [caption]="col.alias"
                                [groupIndex]="col.groupIdx"
                                [fixed]="false"
                                [allowResizing]="true"
                                [allowHiding]="true"
                                [allowGrouping]="true"
                                [allowSearch]="col.isSearchable"
                                [allowFiltering]="col.isFilterable"
                                [allowSorting]="true"
                                [alignment]="'left'"
                                [visibleIndex]="col.visibleIndex"
                                [allowHeaderFiltering]="col.hasHeaderFilter"
                                [type]="col.type"
                                [format]="col.format"
                                [visible]="col.visible"
                                [sortOrder]="'desc'"
                                cellTemplate="usedDateTemplate"></dxi-column>
                            <dxi-column
                                *ngIf="col.field === 'action'"
                                [dataField]="col.field"
                                [caption]="col.alias"
                                [groupIndex]="col.groupIdx"
                                [fixed]="false"
                                [allowResizing]="true"
                                [allowHiding]="true"
                                [allowGrouping]="true"
                                [visible]="col.visible"
                                [allowSearch]="col.isSearchable"
                                [allowFiltering]="col.isFilterable"
                                [allowSorting]="false"
                                [format]="col.format"
                                [alignment]="'left'"
                                [visibleIndex]="col.visibleIndex"
                                [sortable]="false"
                                [allowHeaderFiltering]="col.hasHeaderFilter"
                                cellTemplate="actionTemplate"></dxi-column>
                            <dxi-column
                                *ngIf="col.field === 'details'"
                                [dataField]="col.field"
                                [caption]="col.alias"
                                [groupIndex]="col.groupIdx"
                                [fixed]="false"
                                [allowResizing]="true"
                                [allowHiding]="true"
                                [allowGrouping]="true"
                                [visible]="col.visible"
                                [allowSearch]="col.isSearchable"
                                [allowFiltering]="col.isFilterable"
                                [allowSorting]="false"
                                [format]="col.format"
                                [alignment]="'left'"
                                [visibleIndex]="col.visibleIndex"
                                [allowHeaderFiltering]="col.hasHeaderFilter"
                                cellTemplate="detailsTemplate"></dxi-column>
                            <dxi-column
                                *ngIf="col.field === 'element'"
                                [dataField]="col.field"
                                [caption]="col.alias"
                                [groupIndex]="col.groupIdx"
                                [fixed]="false"
                                [allowResizing]="true"
                                [allowHiding]="true"
                                [allowGrouping]="true"
                                [visible]="col.visible"
                                [allowSearch]="col.isSearchable"
                                [allowFiltering]="col.isFilterable"
                                [allowSorting]="false"
                                [format]="col.format"
                                [alignment]="'left'"
                                [visibleIndex]="col.visibleIndex"
                                [allowHeaderFiltering]="col.hasHeaderFilter"
                                cellTemplate="elementTemplate"></dxi-column>
                        </ng-container>

                        <div *dxTemplate="let cell of 'codeTemplate'">
                            <span>{{cell.data['code']}}</span>
                        </div>

                        <div *dxTemplate="let cell of 'usedDateTemplate'">
                            <span>
                                {{ cell.data['usedDate'] | date: 'yyyy-MM-dd HH:mm' }}
                            </span>
                        </div>

                        <div *dxTemplate="let cell of 'actionTemplate'">
                            <span>{{cell.data['action']}}</span>
                        </div>

                        <div *dxTemplate="let cell of 'detailsTemplate'">
                            <span>{{cell.data['details']}}</span>
                        </div>

                        <div *dxTemplate="let cell of 'elementTemplate'">
                            <span>{{cell.data['element']}}</span>
                        </div>

                        <dxo-group-panel [visible]="true"></dxo-group-panel>

                        <!-- Filterable columns	-->
                        <dxo-filter-row
                            [visible]="vo.list.elements.size !== 0"></dxo-filter-row>

                        <!-- Sorting	-->
                        <dxo-sorting mode="multiple"></dxo-sorting>

                        <!-- Pagination -->
                        <dxo-paging [pageSize]="pageSize" [pageIndex]="pageIndex"></dxo-paging>
                        <dxo-pager
                            [visible]="true"
                            [showPageSizeSelector]="true"
                            [allowedPageSizes]="[20, 50, 100]"
                            [showInfo]="true"
                        >
                        </dxo-pager>

                </dx-data-grid>
            </app-panel>
        </app-page-content>
    </app-page>
</ng-container>

